module.exports = __webpack_public_path__ + "img/customerServiceIcon.c6a05f99.svg";